<div class="element-page">
    <div class="row">
        <div class="col-sm-3">
            <div class="">
                <span class="fw-bold">Featured Units </span>
                <p>
                    <ccl-radio-button
                        buttonStyle="c-radiobutton"
                        [name]="'vipUnit'"
                        [id]="'vipUnit'"
                        (cclClick)="catalogLayoutConfig.vipUnit = 'card'"
                        [value]="'card'"
                        [model]="catalogLayoutConfig.vipUnit"
                        >Cards</ccl-radio-button
                    >
                    <img alt="Featured Unit as Cards"
                        [src]="
                            catalogLayoutConfig.vipUnit == 'card'
                                ? 'assets/images/element-page/VIP_Cards_ON.png'
                                : 'assets/images/element-page/VIP_Cards_OFF.png'
                        "
                        class="img-h-100"
                    />
                </p>
                <p>
                    <ccl-radio-button
                        buttonStyle="c-radiobutton"
                        [name]="'vipUnit'"
                        [id]="'vipUnitList'"
                        (cclClick)="catalogLayoutConfig.vipUnit = 'list'"
                        [value]="'list'"
                        [model]="catalogLayoutConfig.vipUnit"
                        >List or Single</ccl-radio-button
                    >
                    <img alt="Featured Unit as List"
                        [src]="
                            catalogLayoutConfig.vipUnit == 'list'
                                ? 'assets/images/element-page/VIP_List_ON.png'
                                : 'assets/images/element-page/VIP_List_OFF.png'
                        "
                        class="img-h-100"
                    />
                </p>
                <p>
                    <ccl-radio-button
                        buttonStyle="c-radiobutton"
                        [name]="'vipUnit'"
                        [id]="'vipUnitNone'"
                        (cclClick)="catalogLayoutConfig.vipUnit = 'none'"
                        [value]="'none'"
                        [model]="catalogLayoutConfig.vipUnit"
                        >None</ccl-radio-button
                    >
                    <img alt="No Featured Unit"
                        [src]="
                            catalogLayoutConfig.vipUnit == 'none'
                                ? 'assets/images/element-page/NONE_ON.png'
                                : 'assets/images/element-page/NONE_OFF.png'
                        "
                        class="img-h-100"
                    />
                </p>
            </div>
        </div>

        <div class="col-sm-6 center-element-image">
            <span>Header</span>
            <div class="ep-center-image">
                <img alt="Featured Cards with Basic Cards"
                    *ngIf="catalogLayoutConfig.vipUnit == 'card' && catalogLayoutConfig.listType == 'card'"
                    src="assets/images/element-page/Page_Cards_Cards.png"
                />
                <img alt="Featured Cards with Basic List"
                    *ngIf="catalogLayoutConfig.vipUnit == 'card' && catalogLayoutConfig.listType == 'list'"
                    src="assets/images/element-page/Page_Cards_List.png"
                />
                <img alt="Featured List with Basic Cards"
                    *ngIf="catalogLayoutConfig.vipUnit == 'list' && catalogLayoutConfig.listType == 'card'"
                    src="assets/images/element-page/Page_List_Cards.png"
                />
                <img alt="Featured List with Basic List"
                    *ngIf="catalogLayoutConfig.vipUnit == 'list' && catalogLayoutConfig.listType == 'list'"
                    src="assets/images/element-page/Page_List_List.png"
                />
                <img alt="No Feature with Basic Cards"
                    *ngIf="catalogLayoutConfig.vipUnit == 'none' && catalogLayoutConfig.listType == 'card'"
                    src="assets/images/element-page/Page_NONE_Cards.png"
                />
                <img alt="No Feature with Basic List"
                    *ngIf="catalogLayoutConfig.vipUnit == 'none' && catalogLayoutConfig.listType == 'list'"
                    src="assets/images/element-page/Page_NONE_List.png"
                />
            </div>
            <span>Footer</span>
        </div>

        <div class="col-sm-3">
            <div class="">
                <span class="fw-bold">Basic Unit</span>
                <p>
                    <ccl-radio-button
                        buttonStyle="c-radiobutton"
                        [name]="'listType'"
                        [id]="'listTypeCard'"
                        (cclClick)="catalogLayoutConfig.listType = 'card'"
                        [value]="'card'"
                        [model]="catalogLayoutConfig.listType"
                        >Cards</ccl-radio-button
                    >
                    <span class="clearfix"></span>
                    <img alt="Basic Unit as Cards"
                        [src]="
                            catalogLayoutConfig.listType == 'card'
                                ? 'assets/images/element-page/General_Cards_ON.png'
                                : 'assets/images/element-page/General_Cards_OFF.png'
                        "
                        class="img-h-100"
                    />
                </p>
                <p>
                    <ccl-radio-button
                        buttonStyle="c-radiobutton"
                        [name]="'listType'"
                        [id]="'listTypeList'"
                        (cclClick)="catalogLayoutConfig.listType = 'list'"
                        [value]="'list'"
                        [model]="catalogLayoutConfig.listType"
                        >List</ccl-radio-button
                    >
                    <span class="clearfix"></span>
                    <img alt="Basic Unit as List"
                        [src]="
                            catalogLayoutConfig.listType == 'list'
                                ? 'assets/images/element-page/General_List_ON.png'
                                : 'assets/images/element-page/General_List_OFF.png'
                        "
                        class="img-h-100"
                    />
                </p>
            </div>
        </div>
    </div>
</div>
